import { render, staticRenderFns } from "./withdrawTransferTrx.vue?vue&type=template&id=8dc10034&scoped=true"
import script from "./withdrawTransferTrx.vue?vue&type=script&lang=js"
export * from "./withdrawTransferTrx.vue?vue&type=script&lang=js"
import style0 from "./withdrawTransferTrx.vue?vue&type=style&index=0&id=8dc10034&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dc10034",
  null
  
)

export default component.exports